import React, { useState } from 'react';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = ({ cartItemsCount, onCartOpen }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-honey-100">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-2 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="w-10 h-10 bg-gradient-to-br from-honey-400 to-honey-600 rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-lg">B</span>
            </div>
            <div>
              <h1 className="text-xl font-bold text-honey-900">Burbujas de mami</h1>
              <p className="text-xs text-honey-700">100% Natural</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('productos')}
              className="text-honey-900 hover:text-honey-600 font-medium transition-colors"
            >
              Productos
            </button>
            <button
              onClick={() => scrollToSection('sobre-nosotros')}
              className="text-honey-900 hover:text-honey-600 font-medium transition-colors"
            >
              Sobre nosotros
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-honey-900 hover:text-honey-600 font-medium transition-colors"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="text-honey-900 hover:text-honey-600 font-medium transition-colors"
            >
              Contacto
            </button>
          </nav>

          {/* Cart and Mobile Menu */}
          <div className="flex items-center space-x-4">
            <Button
              variant="outline"
              size="icon"
              className="relative border-honey-300 hover:bg-honey-50 hover:border-honey-400"
              onClick={onCartOpen}
            >
              <ShoppingCart className="h-5 w-5 text-honey-900" />
              {cartItemsCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-honey-600 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {cartItemsCount}
                </span>
              )}
            </Button>

            {/* Mobile Menu Button */}
            <Button
              variant="ghost"
              size="icon"
              className="md:hidden"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col space-y-3 border-t border-honey-100 pt-4">
            <button
              onClick={() => scrollToSection('productos')}
              className="text-left text-honey-900 hover:text-honey-600 font-medium py-2 transition-colors"
            >
              Productos
            </button>
            <button
              onClick={() => scrollToSection('sobre-nosotros')}
              className="text-left text-honey-900 hover:text-honey-600 font-medium py-2 transition-colors"
            >
              Sobre nosotros
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-left text-honey-900 hover:text-honey-600 font-medium py-2 transition-colors"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="text-left text-honey-900 hover:text-honey-600 font-medium py-2 transition-colors"
            >
              Contacto
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};
